export const ONE_MEGABYTE = 1_048_576;

export const INITIAL_VALUES = {
  sendFromEmail: "",
  replyToEmail: "",
  notifyEmails: [],
  emailSubject: "",
  emailBody: "",
  isSendLaterEnabled: false,
  sendEmailDatetime: undefined,
  category: "email_share",
  actionButtonText: "",
};

export const EDITOR_ADDONS = [
  "emoji",
  "block-quote",
  "image-upload",
  "divider",
];

export const ALLOWED_FILE_PICKER_TYPES = [".csv"];

export const TIME_FORMAT = "hh:mm A";
